import React, { useCallback, useEffect, useState } from 'react';

import { useCellSelectionContext } from '../../../CellSelectionProvider';
import { CellType } from '../../../RecyclerGridView/types';
import Cell from '../Cell';
import { NormalCellMobileProps } from '../types';

const NormalCellMobile = ({
    config,
    item,
    appState,
    renderContent,
    onPress,
}: NormalCellMobileProps) => {
    const [selected, setSelected] = useState(false);
    const { selectedCell } = useCellSelectionContext();

    const _onPress = useCallback(() => {
        onPress?.(item);
    }, [item, onPress]);

    useEffect(() => {
        setSelected(selectedCell?.id === item.id);
    }, [item, selectedCell]);

    return (
        <Cell
            config={config}
            item={item}
            renderContent={renderContent}
            onPress={_onPress}
            selected={selected}
            focusable={item.type === CellType.Program}
            appState={appState}
        />
    );
};

export default NormalCellMobile;
